module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markers-container"
  }, [_c('div', {
    staticClass: "markers-title"
  }, [_vm._v(_vm._s(_vm.$l('graphs/markers')))]), _vm._v(" "), _c('div', {
    staticClass: "markers-add-button",
    on: {
      "click": _vm.addMarkerClicked
    }
  }, [_c('icon', {
    attrs: {
      "name": "plus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "markers-close-button",
    on: {
      "click": function($event) {
        _vm.data.visible = false
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.getLocalSettings.markers), function(marker) {
    return _c('div', {
      key: marker.id,
      staticClass: "marker-item"
    }, [_c('div', {
      staticClass: "marker-item-title",
      class: {
        enabled: _vm.editingMarker == marker.id, activated: _vm.activeToggleMarkers[marker.id] == true
      }
    }, [(_vm.editingMarker != marker.id) ? _c('div', {
      directives: [{
        name: "shortkey",
        rawName: "v-shortkey",
        value: ([marker.keyCombo.modifier, marker.keyCombo.key]),
        expression: "[marker.keyCombo.modifier, marker.keyCombo.key]"
      }],
      staticClass: "marker-click-hotspot",
      on: {
        "shortkey": function($event) {
          return _vm.markerClicked(marker.id)
        },
        "click": function($event) {
          return _vm.markerClicked(marker.id)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "marker-color",
      style: ({
        backgroundColor: marker.color
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "marker-name"
    }, [(_vm.editingMarker != marker.id) ? _c('div', [_vm._v("\n                    " + _vm._s(marker.name) + " \n                    "), _c('span', {
      staticClass: "marker-name-type"
    }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/' + (marker.type ? 'toggle' : 'single'))))])]) : _vm._e(), _vm._v(" "), (_vm.editingMarker == marker.id) ? _c('div', [_c('el-input', {
      staticClass: "marker-name-input",
      attrs: {
        "size": "small"
      },
      model: {
        value: (marker.name),
        callback: function($$v) {
          _vm.$set(marker, "name", $$v)
        },
        expression: "marker.name"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "marker-name-input-line"
    })], 1) : _vm._e()]), _vm._v(" "), (_vm.editingMarker != marker.id) ? _c('el-button', {
      staticClass: "marker-edit-button",
      attrs: {
        "type": "primary",
        "size": "mini",
        "icon": "edit"
      },
      on: {
        "click": function($event) {
          return _vm.editMarker(marker.id)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.editingMarker == marker.id) ? _c('el-button', {
      staticClass: "marker-edit-button visible-button",
      attrs: {
        "type": "success",
        "size": "mini",
        "icon": "check"
      },
      on: {
        "click": function($event) {
          return _vm.editMarker(marker.id)
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editingMarker == marker.id),
        expression: "editingMarker == marker.id"
      }],
      staticClass: "marker-item-edit"
    }, [_c('el-row', {
      staticClass: "marker-item-edit-row"
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_vm._v("\n                          \n                        "), _c('div', {
      staticClass: "marker-item-edit-title vertical-align"
    }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/type')) + ":")])]), _vm._v(" "), _c('el-col', {
      staticClass: "center-align",
      attrs: {
        "span": 12
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.$l('graphs/markersCat/single')) + "\n                            "), _c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (marker.type),
        callback: function($$v) {
          _vm.$set(marker, "type", $$v)
        },
        expression: "marker.type"
      }
    }), _vm._v("\n                            " + _vm._s(_vm.$l('graphs/markersCat/toggle')) + "\n                    ")], 1)], 1), _vm._v(" "), _c('el-row', {
      staticClass: "marker-item-edit-row"
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_vm._v("\n                          \n                        "), _c('div', {
      staticClass: "marker-item-edit-title vertical-align"
    }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/color')) + ":")])]), _vm._v(" "), _c('el-col', {
      staticClass: "center-align",
      attrs: {
        "span": 12
      }
    }, [_c('el-color-picker', {
      staticClass: "marker-color-picker",
      model: {
        value: (marker.color),
        callback: function($$v) {
          _vm.$set(marker, "color", $$v)
        },
        expression: "marker.color"
      }
    })], 1)], 1), _vm._v(" "), _c('el-row', {
      staticClass: "marker-item-edit-row"
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_vm._v("\n                          \n                        "), _c('div', {
      staticClass: "marker-item-edit-title vertical-align"
    }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/keybind')) + ":")])]), _vm._v(" "), _c('el-col', {
      staticClass: "center-align",
      attrs: {
        "span": 12
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-select', {
      attrs: {
        "size": "mini",
        "filterable": "",
        "placeholder": "Select"
      },
      model: {
        value: (marker.keyCombo.modifier),
        callback: function($$v) {
          _vm.$set(marker.keyCombo, "modifier", $$v)
        },
        expression: "marker.keyCombo.modifier"
      }
    }, [_c('el-option', {
      key: "alt",
      attrs: {
        "label": _vm.$l('graphs/markersCat/alt'),
        "value": "alt"
      }
    }), _vm._v(" "), _c('el-option', {
      key: "shift",
      attrs: {
        "label": _vm.$l('graphs/markersCat/shift'),
        "value": "shift"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-select', {
      attrs: {
        "size": "mini",
        "filterable": "",
        "placeholder": "Select"
      },
      model: {
        value: (marker.keyCombo.key),
        callback: function($$v) {
          _vm.$set(marker.keyCombo, "key", $$v)
        },
        expression: "marker.keyCombo.key"
      }
    }, _vm._l((_vm.keys), function(key) {
      return _c('el-option', {
        key: key,
        attrs: {
          "label": key,
          "value": key
        }
      })
    }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
      staticClass: "marker-item-edit-row buttons"
    }, [_c('el-col', {
      staticClass: "delete-button",
      attrs: {
        "span": 11
      }
    }, [_c('el-button', {
      attrs: {
        "size": "small",
        "icon": "delete",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.deleteClicked(marker.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/delete')))])], 1), _vm._v(" "), _c('el-col', {
      staticClass: "save-button",
      attrs: {
        "span": 11
      }
    }, [_c('el-button', {
      attrs: {
        "size": "small",
        "icon": "check",
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.editMarker(marker.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/save')))])], 1)], 1)], 1)])], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04549a1e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/graphs/MarkersPopover.vue
// module id = 440
// module chunks = 1